interface StepHeaderProps {
  type: 'loved-one' | 'caregiver'
  title: string
  lovedOneName?: string
}

/**
 * Subtle header banner to distinguish between loved one and caregiver questions
 * Provides clear visual context for which person the questions are about
 */
export function StepHeader({ type, title, lovedOneName }: StepHeaderProps) {
  const isLovedOne = type === 'loved-one'

  const containerStyles = {
    backgroundColor: '#f8f9fa',
    padding: '12px 16px',
    borderRadius: '8px',
    marginBottom: '1.5rem',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    borderLeft: isLovedOne ? '4px solid #007AFF' : '4px solid #34c759',
  }

  const labelStyles = {
    fontSize: '11px',
    fontWeight: 600,
    color: '#666',
    letterSpacing: '0.5px',
    textTransform: 'uppercase' as const,
  }

  const titleStyles = {
    fontSize: '16px',
    fontWeight: 600,
    color: '#1a1a1a',
    marginTop: '2px',
  }

  return (
    <div style={containerStyles}>
      <span style={{ fontSize: '24px' }}>{isLovedOne ? '❤️' : '🤝'}</span>
      <div style={{ flex: 1 }}>
        <div style={labelStyles}>
          {isLovedOne
            ? lovedOneName
              ? `ABOUT ${lovedOneName.toUpperCase()}`
              : 'ABOUT YOUR LOVED ONE'
            : 'ABOUT YOU'}
        </div>
        <div style={titleStyles}>{title}</div>
      </div>
    </div>
  )
}
